import React from 'react';
import { ThemeToggle } from './ThemeToggle';
interface NavbarProps {
  openModal: () => void;
  isDark: boolean;
  toggleTheme: () => void;
}
export function Navbar({
  openModal,
  isDark,
  toggleTheme
}: NavbarProps) {
  return <nav className="fixed top-0 left-0 w-full flex justify-between items-center px-6 md:px-12 py-6 z-30 transition-colors duration-500" data-id="element-157">
      <div className="text-xl font-light tracking-tighter" data-id="element-158">caltalk</div>
      <div className="flex items-center space-x-8" data-id="element-159">
        <ThemeToggle isDark={isDark} toggleTheme={toggleTheme} data-id="element-160" />
        <button onClick={openModal} className="px-5 py-2 text-sm font-light rounded-full bg-transparent border border-black/10 dark:border-white/10 hover:border-mint-500 dark:hover:border-mint-400 hover:text-mint-600 dark:hover:text-mint-400 transition-all duration-300" data-id="element-161">
          join waitlist
        </button>
      </div>
    </nav>;
}